import { createAction } from '@reduxjs/toolkit';

import { IUser } from 'state/types';

export const updateUserDetails = createAction<IUser>('user/updateUserDetails');

export const signOutUser = createAction('user/signOutUser');
